/**
 * Fechas del formulario del médico.
 *
 * El <input type="date"> entrega "YYYY-MM-DD" sin zona. Si ese texto viaja tal
 * cual, el backend lo interpreta como medianoche UTC, que en Bogotá es el día
 * anterior a las 7 p. m., y el PDF (que imprime en hora de Bogotá) saldría con
 * un día de menos: en un certificado de incapacidad eso mueve el inicio y el fin.
 * Colombia no tiene horario de verano, así que el desfase es siempre -05:00.
 */

/** "2026-10-05" → "2026-10-05T05:00:00.000Z" (medianoche de Bogotá). */
export function toBogotaIso(dateInput) {
  if (!dateInput || !/^\d{4}-\d{2}-\d{2}$/.test(dateInput)) return undefined;
  const d = new Date(`${dateInput}T00:00:00-05:00`);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}

/** Instante guardado → "YYYY-MM-DD" del día de Bogotá, para el <input type="date">. */
export function fromIsoToDateInput(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  // en-CA formatea como YYYY-MM-DD.
  return d.toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}
